import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import "@angular/common/locales/global/en-IN";

import { AppRoutingModule } from 'app-routing.module';
import { AppComponent, SupportSheetComponent } from 'app.component';
import { NotFoundComponent } from 'components/not-found/not-found.component';

import { AuthGuard, LoginGuard } from 'services';
import { InterceptorService, HTTPStatus } from 'services/interceptor.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatSnackBarModule } from '@angular/material/snack-bar';

import { HttpService } from 'services/http.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataService } from 'services/data.service';
import { CompostService } from 'services/compost.service';
// import { CookieService } from 'ngx-cookie-service';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { UnauthorisedComponent } from 'components/unauthorised/unauthorised.component';
import { SharedModule } from 'shared/shared.module';
import './stringExtensions';
import { MatDialogModule } from '@angular/material/dialog';

const RxJsServices = [
  AuthGuard, LoginGuard,
  HttpService, DataService,
  HTTPStatus,
  // CookieService,
  CompostService
];

@NgModule({
  declarations: [AppComponent, SupportSheetComponent, NotFoundComponent, UnauthorisedComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    SharedModule,
    MatBottomSheetModule, MatIconModule,
    FormsModule, ReactiveFormsModule,MatDialogModule
  ],
  entryComponents: [SupportSheetComponent],
  providers: [
    ...RxJsServices,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'en_IN' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
